/* Dauber HQ hero board tilt.
 * Scroll-linked rotateX on [data-hero-tilt] (the hero app mockup): tilted back at
 * the top, straightens as you scroll into the hero, fully reversible. Mirrors the
 * parallax.js pattern (rAF, passive listeners, prefers-reduced-motion guard).
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var el = document.querySelector('[data-hero-tilt]');
  if (!el) return;

  var MAX = 6;     // degrees tilted back at the very top
  var dist = 380;  // px of scroll over which it straightens (recomputed from vh)
  var raf = 0;

  function measure() {
    // Straighten over a shorter run so the board reads flat before it tucks
    // up under the nav, not just as it reaches it.
    dist = Math.min(window.innerHeight * 0.42, 380);
  }

  function update() {
    raf = 0;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var p = dist > 0 ? Math.max(0, Math.min(1, 1 - y / dist)) : 0; // 1 at top → 0 past dist
    el.style.transform = 'rotateX(' + (MAX * p).toFixed(2) + 'deg)';
  }

  function onScroll() {
    if (!raf) raf = requestAnimationFrame(update);
  }

  measure();
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
})();
